import React from "react";
import { getImageUrl } from "../../utils/imageUtils";

/**
 * Static World Map Component
 * A lightweight image-based world map that doesn't cause scroll jank
 * Replaces the heavy Leaflet map for better performance
 */
export const StaticWorldMap: React.FC = () => {
  return (
    <div
      className="static-world-map absolute inset-0 w-full h-full overflow-hidden"
      style={{
        backgroundColor: "#0d0d0d",
        contain: "strict",
      }}
    >
      {/* World map SVG image */}
      <img
        src={getImageUrl("/images/maps/world-map.svg")}
        alt=""
        className="absolute w-full h-full object-cover"
        style={{
          opacity: 0.25,
          filter: "invert(1) brightness(0.7)",
          objectPosition: "0% 0%", // Focus on Europe/Germany area
        }}
      />

      {/* Subtle gradient overlay for depth */}
      <div
        className="absolute inset-0"
        style={{
          background:
            "radial-gradient(ellipse at 60% 40%, transparent 30%, rgba(13, 13, 13, 0.5) 100%)",
          pointerEvents: "none",
        }}
      />
    </div>
  );
};
